import { render } from "./app-tabs.vue?vue&type=template&id=b86c06c6&scoped=true"
import script from "./app-tabs.vue?vue&type=script&lang=js"
export * from "./app-tabs.vue?vue&type=script&lang=js"

import "./app-tabs.vue?vue&type=style&index=0&id=b86c06c6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86c06c6"]])

export default __exports__